import { Rect, Scale, Size } from "../.././MyHelpers";
import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../../slot/ExpandingWildBulk";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";
// namespace SlotGames
// {

export class NordicFuryFillingPot extends SlotGameType1 {	
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "NordicFuryFillingPot");
		//this.spinnableReelsParams.topBorderWidth = 7;
		//this.spinnableReelsParams.bottomBorderWidth = 7;
	}
}